var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _path7, _line, _line2, _polygon, _circle6, _path8, _line3, _line4, _polygon2, _circle7, _path9, _line5, _line6, _polygon3, _circle8, _path10, _line7, _line8, _polygon4, _circle9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommand01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill:#fff;stroke:#000;stroke-linejoin:round;}.cls-1,.cls-2{stroke-linecap:round;}.cls-1{stroke-width:2.86px;}.cls-2{stroke-width:2.24px;}.cls-3{stroke-width:1.5px;}.cls-4{stroke-width:1.18px;}.cls-5{stroke-width:1.14px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.07,111.69c1,.72,1,3.19,1.12,6.91a35.31,35.31,0,0,1-.37,6.25c-2.18,13.53-.65,37.53-2.89,65.05A25.93,25.93,0,0,0,316,203.52a24.32,24.32,0,0,0,6.62,8.4c-3.35,1.8-9.07,4.21-15.11,2.8-20.55-4.78-34.72-51.27-18.95-79.88C296.69,120.05,313.13,109.49,316.07,111.69Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106,111.69c-1,.72-1,3.19-1.12,6.91a35.31,35.31,0,0,0,.37,6.25c2.18,13.53.65,37.53,2.89,65.05a25.93,25.93,0,0,1-2,13.62,24.32,24.32,0,0,1-6.62,8.4c3.35,1.8,9.07,4.21,15.11,2.8,20.55-4.78,34.72-51.27,19-79.88C125.4,120.05,109,109.49,106,111.69Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M260.53,91.07a11.61,11.61,0,0,1-5-3.73c-1.63-2.19-2.36-5-3.49-9.38-.59-2.29-.74-3.36-1.74-4.53A7.81,7.81,0,0,0,245.66,71a18.58,18.58,0,0,1-.13,6.4,17.56,17.56,0,0,1-2.67,6.48c-2.44,3.51-5.79,4.87-10.13,6.63-4,1.63-7.11,2.17-12.53,4.48a15.32,15.32,0,0,0-3.85,2.29,13.17,13.17,0,0,0-3.54,4.15c-1.33,2.53-1.41,4.89-1.51,7.7-.07,1.93-.1,2.9.14,3.4,2.23,4.75,20.33.27,22.71-.32,11.41-2.83,22.77-5.65,25.78-14.42A14.7,14.7,0,0,0,260.53,91.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.46,91.07a11.48,11.48,0,0,0,5-3.73c1.64-2.19,2.37-5,3.49-9.38.6-2.29.75-3.36,1.75-4.53A7.81,7.81,0,0,1,176.34,71a18.63,18.63,0,0,0,.14,6.4,17.66,17.66,0,0,0,2.66,6.48c2.45,3.51,5.8,4.87,10.15,6.63,4,1.63,7.11,2.17,12.54,4.48a15.32,15.32,0,0,1,3.85,2.29,13.17,13.17,0,0,1,3.54,4.15c1.34,2.53,1.42,4.89,1.52,7.7.06,1.93.1,2.9-.14,3.4-2.24,4.75-20.35.27-22.73-.32-11.43-2.83-22.8-5.65-25.81-14.42A14.84,14.84,0,0,1,161.46,91.07Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.74,110.39c-4-.82-5.83-.74-10-2a48.07,48.07,0,0,1-9.95-4.36c-4-2.32-9.15-5.27-12.82-11.2a26,26,0,0,1-2.11-4.23L106,111a118.58,118.58,0,0,1,6,17.54c2.31,9.06,2.88,15.7,3.85,28,1.38,17.28.57,24.35.13,27.5-1.25,9-3.14,12.89-4.48,15.18a33.72,33.72,0,0,1-12.19,12c1.9,9.68,4.17,23,5.84,38.94a494.58,494.58,0,0,1,2,67.82c-.53,15.24-1.52,25.71-3.48,46-1.74,18-4.41,42.31-8.59,71.3,2.71,1,6.74,2.42,11.7,3.85,11.31,3.29,23.59,5.57,48.78,7,13,.73,29.51,1.23,48.9.75q5-165.87,9.95-331.73A57.71,57.71,0,0,0,200.74,110.39Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.62,111a84.51,84.51,0,0,0,23.27-1.12c8.21-1.56,16.3-3.1,23.89-9.46a38.66,38.66,0,0,0,9.58-12.19l60,23.14a199.48,199.48,0,0,0-9.45,41.07c-1.08,9-.89,15.3-.5,27.87.07,2.19.49,13.17,5.1,20.9a28.07,28.07,0,0,0,3.24,4.36,26.14,26.14,0,0,0,8.83,6.22c-2,9.81-4.32,23.43-6,39.82-2.42,24-2.16,42.36-1.87,58.6A508.37,508.37,0,0,0,319.2,367c1.72,14.09,4.13,28.37,7.83,60.11.38,3.17.67,5.8.88,7.59-4.49,1.46-10.93,3.43-18.79,5.35-18.37,4.47-32.41,5.69-49.28,7.09-19.56,1.62-35.43,1.76-48,1.87-5.76,0-10.56,0-13.94,0,0-2.17.12-26.54.13-28.75Q198.68,265.63,199.62,111Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 207.61,
    cy: 120.22,
    r: 4.57
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.61,
    cy: 173.16,
    r: 4.57
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.61,
    cy: 226.1,
    r: 4.57
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.61,
    cy: 279.05,
    r: 4.57
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.61,
    cy: 331.99,
    r: 4.57
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M232.89,324.47h62a0,0,0,0,1,0,0v54a12.67,12.67,0,0,1-12.67,12.67H245.56a12.67,12.67,0,0,1-12.67-12.67v-54A0,0,0,0,1,232.89,324.47Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 258.22,
    y1: 324.47,
    x2: 258.22,
    y2: 391.14
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 269.56,
    y1: 324.47,
    x2: 269.56,
    y2: 391.14
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "295.5 340.49 263.89 350.49 232.28 340.49 232.28 323.99 295.5 323.99 295.5 340.49"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 263.89,
    cy: 341.81,
    r: 4.57
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239.84,175.34h48.09a0,0,0,0,1,0,0v43.41a10,10,0,0,1-10,10H249.83a10,10,0,0,1-10-10V175.34A0,0,0,0,1,239.84,175.34Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 259.49,
    y1: 175.34,
    x2: 259.49,
    y2: 228.73
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 268.29,
    y1: 175.34,
    x2: 268.29,
    y2: 228.73
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "288.41 187.26 263.89 194.72 239.37 187.26 239.37 174.95 288.41 174.95 288.41 187.26"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 263.89,
    cy: 187.21,
    r: 4.57
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.86,175.55H182a0,0,0,0,1,0,0V219a10,10,0,0,1-10,10H143.84a10,10,0,0,1-10-10V175.55A0,0,0,0,1,133.86,175.55Z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 153.51,
    y1: 175.55,
    x2: 153.51,
    y2: 228.94
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 162.3,
    y1: 175.55,
    x2: 162.3,
    y2: 228.94
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "182.43 187.47 157.91 194.93 133.38 187.47 133.38 175.16 182.43 175.16 182.43 187.47"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.9,
    cy: 187.42,
    r: 4.57
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.33,324.71h62a0,0,0,0,1,0,0v54a12.67,12.67,0,0,1-12.67,12.67H137a12.67,12.67,0,0,1-12.67-12.67v-54A0,0,0,0,1,124.33,324.71Z"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 149.66,
    y1: 324.71,
    x2: 149.66,
    y2: 391.38
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 161,
    y1: 324.71,
    x2: 161,
    y2: 391.38
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "186.94 340.73 155.33 350.73 123.72 340.73 123.72 324.23 186.94 324.23 186.94 340.73"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.33,
    cy: 342.06,
    r: 4.57
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommand01);
export default __webpack_public_path__ + "static/media/Command-01.db9a5493db8633395a32d5ecfeb04eed.svg";
export { ForwardRef as ReactComponent };